module.exports = __webpack_public_path__ + "static/media/logo-fastgestor-pequeno.b8786c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/logo-fastgestor-pequeno.png
// module id = 635
// module chunks = 0